import { render } from "./RuntimeOverview.vue?vue&type=template&id=fdd1bf14"
import script from "./RuntimeOverview.vue?vue&type=script&lang=js"
export * from "./RuntimeOverview.vue?vue&type=script&lang=js"

import "./RuntimeOverview.vue?vue&type=style&index=0&id=fdd1bf14&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__